export const GUILD_PREMIUM_MONTHLY_STANDARD_PRICE = 2000

export const GUILD_BASIC_MONTHLY_STANDARD_PRICE = 1200

/** The price the user would pay if they signed up monthly at full price over 12 months **/
export const GUILD_PREMIUM_YEARLY_FULL_PRICE = 24000

/** The standard discounted pricing for Premium Yearly **/
export const GUILD_PREMIUM_YEARLY_STANDARD_PRICE = 17900

/** The price the user would pay if they signed up monthly at full price over 12 months **/
export const GUILD_BASIC_YEARLY_FULL_PRICE = 14400

/** The standard discounted pricing for Premium Yearly **/
export const GUILD_BASIC_YEARLY_STANDARD_PRICE = 11900
